export const BASE_URL = 'https://fincensafe.com/api/';
export const TrackingID = 'GTM-MPFM6BQB'